import React, { useState, useEffect } from 'react'
import { withStyles } from '@material-ui/core/styles'
import green from '@material-ui/core/colors/green'
import { Button, Divider, Grid, IconButton, Paper, Tooltip, Typography } from '@material-ui/core'
import CloseIcon from '@material-ui/icons/Close'
import EditIcon from '@material-ui/icons/Edit'
import Editor, { BtnBold, BtnItalic, BtnStyles, Toolbar } from 'react-simple-wysiwyg'
import { useQuery, useMutation } from '@apollo/client'
import { getSettings, updateSettings } from '../../../graphql/settings'
import FeedbackSnackbar from '../../../components/feedback_snackbar'
import { withApollo } from '@apollo/client/react/hoc'
import compose from '../../../utils/functions'
import { getUserById } from '../../../graphql/user'

const styles = (theme) => ({
    root: {
        display: 'flex',
        flex: 1,
    },
    paperRoot: {},
    cardHeader: {
        display: 'flex',
        flex: 1,
        flexDirection: 'row',
        alignItems: 'center',
        padding: theme.spacing.unit * 3,
        justifyContent: 'space-between',
        height: '80px',
    },
    cardFooter: {
        display: 'flex',
        flex: 1,
        flexDirection: 'row',
        alignItems: 'center',
        padding: theme.spacing.unit * 3,
        justifyContent: 'flex-end',
        height: '80px',
    },
    cardTitleContainer: {
        display: 'flex',
        flex: 1,
        flexDirection: 'row',
        alignItems: 'center',
    },
    title: {},
    cardContainer: {
        padding: theme.spacing.unit * 3,
    },
    labelTitle: {
        fontWeight: 'bold',
        textTransform: 'uppercase',
        color: theme.palette.primary.light,
    },
    label: {
        fontWeight: 'normal',
        fontSize: '16px',
    },
    actions: {
        marginRight: -theme.spacing.unit * 2,
    },
    actionButton: {
        marginLeft: '8px',
        [theme.breakpoints.down('xs')]: {
            width: '100%',
            marginTop: 8,
            marginBottom: 8,
        },
    },
    success: {
        backgroundColor: green[600],
    },
    icon: {
        fontSize: 20,
    },
    iconVariant: {
        opacity: 0.9,
        marginRight: theme.spacing.unit,
    },
    message: {
        display: 'flex',
        alignItems: 'center',
    },
    link: {
        textDecoration: 'none',
    },
})

const SettingsDetail = ({ classes, client }) => {
    const [editTsMessage, setEditTsMessage] = useState(false)
    const [tsMessage, setTsMessage] = useState('')
    const [value, setValue] = useState('')
    const [snackbar, setSnackbar] = useState({ open: false, message: '', variant: 'success' })

    useEffect(() => {
        fetchSettings()
    }, [])

    const fetchSettings = () => {
        client.query(getSettings()).then((result) => {
            if (result.data && result.data.getSettings) {
                setTsMessage(result.data.getSettings.tsMessage || '')
                setValue(result.data.getSettings.tsMessage || '')
            }
        })
    }

    const onChange = (e) => {
        setValue(e.target.value)
    }

    const handleUpdateTsMessage = async () => {
        try {
            await client.mutate(updateSettings(value))
            setTsMessage(value)
            setEditTsMessage(false)
            fetchSettings()
            setSnackbar({ open: true, message: 'Missatge actualitzat correctament', variant: 'success' })
        } catch (err) {
            setSnackbar({ open: true, message: 'Error actualitzant el missatge', variant: 'error' })
            console.error(err)
        }
    }

    return (
        <div className={classes.root}>
            <Grid container spacing={24}>
                <Grid item xs={12} sm={12} md={6}>
                    <Paper className={classes.paperRoot}>
                        <div className={classes.cardHeader}>
                            <div className={classes.cardTitleContainer}>
                                <Typography className={classes.title} variant="h6" color="primary">
                                    Missatge per als treballadors socials:
                                </Typography>
                            </div>
                            <Tooltip title="Editar">
                                {editTsMessage ? (
                                    <IconButton
                                        aria-label="Editar"
                                        className={classes.actions}
                                        onClick={() => setEditTsMessage(false)}>
                                        <CloseIcon />
                                    </IconButton>
                                ) : (
                                    <IconButton
                                        aria-label="Editar"
                                        className={classes.actions}
                                        onClick={() => setEditTsMessage(true)}>
                                        <EditIcon />
                                    </IconButton>
                                )}
                            </Tooltip>
                        </div>
                        <Divider />
                        {editTsMessage ? (
                            <Grid className={classes.cardContainer} container spacing={16}>
                                <Grid item xs={12}>
                                    <Editor value={value} onChange={onChange}>
                                        <Toolbar>
                                            <BtnBold />
                                            <BtnItalic />
                                            <BtnStyles />
                                        </Toolbar>
                                    </Editor>
                                </Grid>
                                <Divider />
                                <div className={classes.cardFooter}>
                                    <Button
                                        variant="outlined"
                                        color="secondary"
                                        size="large"
                                        className={classes.actionButton}
                                        onClick={() => setEditTsMessage(false)}>
                                        Cancel·lar
                                    </Button>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        size="large"
                                        className={classes.actionButton}
                                        onClick={() => handleUpdateTsMessage()}>
                                        Desar els canvis
                                    </Button>
                                </div>
                            </Grid>
                        ) : (
                            <div>
                                <Grid className={classes.cardContainer} container spacing={16}>
                                    <Grid item xs={12}>
                                        <Typography
                                            className={classes.label}
                                            component="div"
                                            dangerouslySetInnerHTML={{ __html: tsMessage }}
                                        />
                                    </Grid>
                                </Grid>
                            </div>
                        )}
                    </Paper>
                </Grid>
            </Grid>
            <FeedbackSnackbar
                showSnackbar={snackbar.open}
                handleClose={() => setSnackbar({ ...snackbar, open: false })}
                timeShowed={3000}
                text={snackbar.message}
                variant={snackbar.variant}
            />
        </div>
    )
}

export default compose(withApollo, withStyles(styles))(SettingsDetail)
